import { Controller } from "@hotwired/stimulus";

// Shows/hides the clear (x) button in .search-combo based on input value
export default class extends Controller {
  static targets = ["input", "clear"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly clearTarget: HTMLButtonElement;

  toggle() {
    this.clearTarget.hidden = this.inputTarget.value.length === 0;
  }

  clear() {
    this.inputTarget.value = "";
    this.inputTarget.focus();
    this.toggle();
  }
}
